export enum PlaybookType {
  System = "system",
  User = "user",
}
